import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { withContent } from 'components/Content';
import FormsMapper from 'components/ContentfulFields/FormsMapper';
import { injectVariables } from 'utils/translation';
import { selectAcquisitionVariables } from 'containers/Landing/selectors';
import { getRegionalBrandName } from 'utils/domainHelper';

import styles from './mainBanner.scss';

const CONTENT_KEYS = {
  title: 'Title',
  disclaimer: 'Disclaimer',
  description: 'Description',
  form: 'Zip Form',
  image: 'Branded Bottled',
};

const MainBanner = ({ content }) => {
  const { title, description, form, disclaimer, image } = content;
  const acquisitionVariables = useSelector(selectAcquisitionVariables());
  const regionalBrandName = getRegionalBrandName();

  return (
    <div className={styles.mainBanner}>
      <div className={styles.content}>
        <div className={styles.wrapper}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.description}>{description}</p>
          <FormsMapper document={form} type={form.fields.type} />
          <p className={styles.disclaimer}>
            {injectVariables(
              disclaimer,
              regionalBrandName,
              acquisitionVariables,
              '',
            )}
          </p>
        </div>
        <div className={styles.images}>
          <img
            src={`${get(image, 'fields.file.url')}?fm=webp`}
            alt={get(image, 'fields.description')}
          />
        </div>
      </div>
    </div>
  );
};

export default withContent(CONTENT_KEYS)(MainBanner);
